<template>
  <div class="mobile-player">
    <img
      class="mobile-player-bg"
      :src="`//qn.cache.wpscdn.cn/vas-frontend-prod/learning-fe/img/cover/single_${data.top_cate}_hd.png`"
    />
    <h1
      class="mobile-player-title ellipsis-2"
      v-html="getCourseBackgroundTitle(data)"
    ></h1>
    <div class="mobile-player-video-box">
      <video-player
        class="mobile-player-video-player"
        @ready="onReady"
        :playerOptions="playerOptions"
      ></video-player>

      <template v-if="isReady">
        <icon
          class="mobile-player-icon"
          v-if="playIconShow"
          @click="$emit('play-click')"
          type="iconic_play"
        ></icon>

        <icon
          class="mobile-player-icon"
          v-if="pauseIconShow"
          @click="$emit('pause-click')"
          type="iconic_pause"
        ></icon>
      </template>
    </div>
  </div>
</template>

<script>
import VideoPlayer from './video-player';
import { getCourseBackgroundTitle } from '@/common/utils';
import VIDEO_LANGUAGE from '@/common/constant/video-language';

export default {
  data() {
    return {
      isReady: false,
    };
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    playIconShow: Boolean,
    pauseIconShow: Boolean,
  },

  computed: {
    playerOptions() {
      const { data } = this;
      if (!data) return {};

      return {
        // videojs options
        controls: true,
        autoplay: false,
        preload: 'none',
        disablePictureInPicture: true,
        playbackRates: [0.5, 1, 1.5, 2],
        width: '196px',
        height: '424px',
        controlBar: {
          /* 使用children的形式可以控制每一个控件的位置，以及显示与否 */
          children: [
            { name: 'playToggle' }, // 播放按钮
            { name: 'progressControl' }, // 播放进度条
            {
              name: 'volumePanel', // 音量控制
              inline: false, // 不使用水平方式
            },
            { name: 'FullscreenToggle' }, // 全屏
          ],
        },
        sources: [
          {
            type: 'video/mp4',
            src: data.post_video.url,
          },
        ],
        poster:
          '//s1.wpsacdm.cache.wpscdn.cn/wps_statics/wps_academy/themes/academy/public/assets/images/mobilecover/cover_common.png', //封面图
        languages: VIDEO_LANGUAGE,
      };
    },
  },

  components: {
    VideoPlayer,
  },

  methods: {
    getCourseBackgroundTitle,

    onReady(player) {
      this.isReady = true;
      this.$emit('ready', player);
    },
  }
};
</script>

<style lang="scss" scoped>
.mobile-player {
  position: relative;

  &-bg {
    display: block;
    width: 100%;
  }

  &-title {
    z-index: 5;
    position: absolute;
    top: 130px;
    left: 80px;
    height: 188px;
    width: 396px;
    color: #ffffff;
    font-weight: 900;
    font-size: 66px;
    line-height: 92px;
    text-align: center;
  }

  &-video-box {
    position: relative;
    overflow: hidden;
    border-radius: 20px;
    z-index: 5;
    position: absolute;
    width: 206px;
    top: 8px;
    left: 515px;
    border: 5px solid #ffffff;
  }

  &-video-player {
    height: 424px;
  }

  &-icon {
    font-size: 69px;
    margin-top: -12px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
  }
}
</style>

<style lang="scss">
/** 调整手机模式下样式 */
.mobile-player {
  .video-js {
    font-size: 10px;
  }
  .vjs-control-bar {
    height: 30px;
  }
  .vjs-control {
    width: 40px;
  }
  .vjs-progress-control {
    min-width: 40px;
  }
  .vjs-volume-bar {
    margin: 13.5px auto;
  }
  .vjs-playback-rate-value {
    line-height: 30px !important;
  }
  .vjs-menu {
    margin-bottom: 15px;
  }
  .vjs-volume-level:before {
    top: -4px;
    right: -5px;
  }
  .vjs-play-progress:before {
    top: -4px;
    right: -5px;
  }
  .vjs-volume-panel.vjs-volume-panel-vertical {
    width: 2em;
  }
}
</style>
